import React from "react";
import "./index.css";
import HomePage from "./HomePage";

function App() {
  return <HomePage />;
}

export default App;
